if (!customElements.get('japanime-product-card')) {
  customElements.define(
    'japanime-product-card',
    class JapanimeProductCard extends HTMLElement {
      connectedCallback() {
        this.initializeWishlistControls();
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.status = this.querySelector('[data-jp-card-status]');
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event?.source !== 'product-form') return;
          if (`${event.productVariantId}` !== this.dataset.variantId) return;
          if (!this.status) return;
          this.status.textContent = this.dataset.successMessage || 'Added to cart';
          window.setTimeout(() => {
            if (this.status) this.status.textContent = '';
          }, 3500);
        });
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        this.wishlistObserver?.disconnect();
        this.wishlistRetryTimers?.forEach((timer) => window.clearTimeout(timer));
      }

      initializeWishlistControls() {
        const selector = '.love-button, .gp-wishlist-button, .quantum-lbw-wishlist-btn, [data-jp-wishlist-fallback]';
        const bindControls = () => {
          this.querySelectorAll(selector).forEach((control) => {
            if (control.dataset.jpWishlistBound === 'true') return;
            control.dataset.jpWishlistBound = 'true';
            control.addEventListener('click', (event) => {
              event.stopPropagation();
              if (!control.matches('[data-jp-wishlist-fallback]')) return;
              event.preventDefault();
              if (control.dataset.jpWishlistProxy === 'true') return;

              this.wishlistFallbackPending = true;
              document.dispatchEvent(new CustomEvent('products:updated'));
              this.wishlistRetryTimers?.forEach((timer) => window.clearTimeout(timer));
              this.wishlistRetryTimers = [350, 900, 1800].map((delay) => window.setTimeout(() => {
                if (this.wishlistFallbackPending) document.dispatchEvent(new CustomEvent('products:updated'));
              }, delay));
              this.wishlistRetryTimers.push(window.setTimeout(() => {
                this.wishlistFallbackPending = false;
              }, 3000));
            });
          });

          const appControl = this.querySelector('.love-button, .gp-wishlist-button, .quantum-lbw-wishlist-btn');
          if (this.wishlistFallbackPending && appControl) {
            this.wishlistFallbackPending = false;
            window.queueMicrotask(() => appControl.isConnected && appControl.click());
          }
        };

        bindControls();
        this.wishlistObserver = new MutationObserver(bindControls);
        this.wishlistObserver.observe(this, { childList: true, subtree: true });
      }
    },
  );
}
